export const STATE = 'chat'

export const SET_CHAT_SCHEDULES = `${STATE}/SCHEDULES`
export const SET_CHAT_REQUESTS = `${STATE}/REQUESTS`
export const SET_CHAT_MEETINGS = `${STATE}/MEETINGS`
export const SET_CHAT_USER = `${STATE}/CHAT_USER`
export const SET_USERS_MESSAGES = `${STATE}/USERS_MESSAGES`
export const SET_CHAT_CATEGORY_OPEN = `${STATE}/CHAT_CATEGORY_OPEN`
export const SET_CHAT_MEETING_DATA = `${STATE}/MEETING_DATA`
export const SET_CHAT_MEETING_NOTIFICATIONS = `${STATE}/MEETING_NOTIFICATIONS`
export const SET_LAST_MESSAGE_ID = `${STATE}/LAST_MESSAGE_ID`
export const SET_UPDATE_MESSAGE = `${STATE}/UPDATE_MESSAGE`
export const SET_IS_MOBILE = `${STATE}/IS_MOBILE`
export const SET_GET_CHATS = `${STATE}/GET_CHATS`
export const SET_CHAT_NOTIFICATION = `${STATE}/CHAT_NOTIFICATION`
export const SET_USER_FROM_ID = `${STATE}/USER_FROM_ID`
